import type { TfClient } from '../client-internal';
import type { Database } from '../types.gen';

export type Event = Database['public']['Tables']['tf_events']['Row'];
export type EventInsert = Database['public']['Tables']['tf_events']['Insert'];

export interface EventFilter {
  sessionId?: string;
  eventType?: Event['event_type'];
  since?: string; // ISO timestamp
  until?: string;
  limit?: number;
}

export async function insertEvent(c: TfClient, input: EventInsert): Promise<void> {
  const { error } = await c.from('tf_events').insert(input);
  if (error) throw error;
}

export async function listEvents(
  c: TfClient,
  toolId: string,
  filter: EventFilter = {},
): Promise<Event[]> {
  let q = c
    .from('tf_events')
    .select('*')
    .eq('tool_id', toolId)
    .order('occurred_at', { ascending: false })
    .limit(filter.limit ?? 200);
  if (filter.sessionId) q = q.eq('session_id', filter.sessionId);
  if (filter.eventType) q = q.eq('event_type', filter.eventType);
  if (filter.since) q = q.gte('occurred_at', filter.since);
  if (filter.until) q = q.lte('occurred_at', filter.until);
  const { data, error } = await q;
  if (error) throw error;
  return data ?? [];
}
